import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import EllipsisHorizontal from 'apollo-react-icons/EllipsisHorizontal';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setSelectedControlObject,
  updateControlProperty,
} from '../../../actions/report-designer.actions';
import PropertyModal from '../../../components/ControlProperty/PropertyModal';
import { getSelectedControlId } from '../../../selectors/report-designer.selectors';
import {
  getDropDownConditionValuesByAccessor,
  getPropertyValueToDisplay,
  isExpressionValue,
} from '../../../utils/report-designer.utils';

const useStyles = makeStyles({
  root: {
    display: 'flex',
  },
  iconButton: {
    marginTop: ({ isInExpandableRow }) => (isInExpandableRow ? 5 : 13),
    width: 35,
    border: '1px solid #d9d9d9',
    borderRadius: '0px 4px 4px 0px',
    borderLeft: 'none',
    backgroundColor: '#fff',
    '&:disabled': {
      borderColor: '#b6b5b5',
    },
  },
  select: {
    margin: ({ isInExpandableRow }) => (isInExpandableRow ? 0 : '8px 0'),
  },
});

const DropDownCell = ({ row, column, isInExpandableRow }) => {
  const classes = useStyles({ isInExpandableRow });
  const dispatch = useDispatch();

  const selectedControlId = useSelector(getSelectedControlId);

  const [openModal, setOpenModal] = useState(false);

  const { accessor, isConditional } = column;
  const { controlId } = row;
  const value = getPropertyValueToDisplay(row[accessor]);
  const values = getDropDownConditionValuesByAccessor(accessor);

  const isConditionalSelect =
    (isConditional && value === 'conditional') || isExpressionValue(value);

  const handleChange = ({ target }) => {
    if (target.value === 'conditional') {
      setOpenModal(true);
      return;
    }

    if (target.value !== value) {
      dispatch(updateControlProperty(controlId, accessor, target.value));
    }
  };

  const handleMouseDownClick = () => {
    if (controlId !== selectedControlId) {
      dispatch(setSelectedControlObject(controlId, false));
    }
  };

  return (
    <>
      <div className={classes.root}>
        <Select
          fullWidth
          className={classes.select}
          canDeselect={false}
          value={isExpressionValue(value) ? 'conditional' : value}
          onChange={handleChange}
          onMouseDown={handleMouseDownClick}
        >
          {values.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
        {isConditionalSelect && (
          <IconButton className={classes.iconButton} onClick={() => setOpenModal(true)}>
            <EllipsisHorizontal />
          </IconButton>
        )}
      </div>
      {openModal && (
        <PropertyModal
          label={accessor}
          controlId={controlId}
          name={accessor}
          onClose={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default DropDownCell;
